import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/documentation/documentation/node_modules/gatsby-theme-doctornpm/src/components/layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`npm, Inc. offers software and services under a few different licenses
and terms of use.`}</p>
    <h2>{`Software from npm`}</h2>
    <p>{`License terms and notices for the `}<inlineCode parentName="p">{`npm`}</inlineCode>{` command-line program can
be found in the LICENSE file of the project's source code at
`}<a parentName="p" {...{
        "href": "https://www.github.com/npm/cli"
      }}>{`https://www.github.com/npm/cli`}</a>{`.`}</p>
    <h2>{`Free to use npm services`}</h2>
    <p>{`Free usage of `}<a parentName="p" {...{
        "href": "https://www.npmjs.com"
      }}>{`https://www.npmjs.com`}</a>{`, and the npm public registry
are covered by the npm Open Source Terms at `}<a parentName="p" {...{
        "href": "https://docs.npmjs.com/policies/open-source-terms"
      }}>{`https://docs.npmjs.com/policies/open-source-terms`}</a>{`.
These terms include several important policies, including:`}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`What npm considers `}<a parentName="p" {...{
            "href": "/policies/open-source-terms#acceptable-use"
          }}>{`acceptable package content`}</a>{`.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`npm's `}<a parentName="p" {...{
            "href": "/policies/conduct"
          }}>{`Code of Conduct`}</a>{`, which includes our policy on harassment.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`npm's `}<a parentName="p" {...{
            "href": "/policies/privacy"
          }}>{`Privacy Policy`}</a>{`, which limits use and sharing of information
about you collected by npm Services.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`npm's policy on `}<a parentName="p" {...{
            "href": "/policies/dmca"
          }}>{`copyright`}</a>{` including how to report violations thereof.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`npm's `}<a parentName="p" {...{
            "href": "/policies/disputes"
          }}>{`Dispute Policy`}</a>{` which addresses how to resolve disputes
over the control of a package name, user name, or organization name in the Public Registry. This includes
our policy on users "squatting" on these names.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Use of npm's trademarks is governed by our `}<a parentName="p" {...{
            "href": "/policies/trademark"
          }}>{`Trademark Policy`}</a>{`. If you
have concerns about your own trademark's use on npm please see our `}<a parentName="p" {...{
            "href": "/policies/disputes#trademarks"
          }}>{`Disputes Policy`}</a>{`.`}</p>
      </li>
    </ul>
    <h2>{`Paid npm services`}</h2>
    <p>{`npm's paid products, including the npm Solo and Orgs plans, are
covered by the npm Paid Services Terms at `}<a parentName="p" {...{
        "href": "https://docs.npmjs.com/policies/private-terms"
      }}>{`https://docs.npmjs.com/policies/private-terms`}</a>{`.`}</p>
    <p>{`The `}<a parentName="p" {...{
        "href": "/policies/solo-plan"
      }}>{`npm Solo Payment Plan`}</a>{`
and the `}<a parentName="p" {...{
        "href": "/policies/orgs-plan"
      }}>{`npm Orgs Payment Plan`}</a>{`
govern payment for these services.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      